export const fonts = {};
